/* tslint:disable */
/* eslint-disable */
/**
 * SI Implicit-Bias API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AuthenticatedModel
 */
export interface AuthenticatedModel {
    /**
     * 
     * @type {string}
     * @memberof AuthenticatedModel
     */
    username: string;
    /**
     * 
     * @type {string}
     * @memberof AuthenticatedModel
     */
    password: string;
}

export function AuthenticatedModelFromJSON(json: any): AuthenticatedModel {
    return AuthenticatedModelFromJSONTyped(json, false);
}

export function AuthenticatedModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuthenticatedModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'username': json['username'],
        'password': json['password'],
    };
}

export function AuthenticatedModelToJSON(value?: AuthenticatedModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'username': value.username,
        'password': value.password,
    };
}


